const initialstate = {
  creating: null,
  creatingSuccessful: null,
  creatingFailed: null,
  error: null,
  errorText: null,
};

const createTestConversationReducer = (state = initialstate, action) => {
  switch (action.type) {
    case 'CREATING_TEST_CONVERSATION':
      return Object.assign({}, state, {
        creating: true,
        creatingSuccessful: null,
        creatingFailed: null,
      });
    case 'CREATING_TEST_CONVERSATION_DONE':
      return Object.assign({}, state, {
        creating: false,
        creatingSuccessful: true,
        creatingFailed: false,
        error: false,
        errorText: '',
      });
    case 'CREATING_TEST_CONVERSATION_FAILED':
      return Object.assign({}, state, {
        creating: false,
        creatingSuccessful: false,
        creatingFailed: true,
        error: true,
        errorText: action.payload,
      });
    default:
      return state;
  }
};

export default createTestConversationReducer;
